<template>
  <div>
    <div class="w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px" :style="`background-color: ${mainColor};`">
      <router-link :to="{ name: 'Cart' }">
        <svg-filler class="mg-r-auto f-left cs-pointer" path="/static/svg/back.svg" :fill="'#ffffff'" width="20px" height="20px"/>
      </router-link>
      <span>
        ช่องทางการชำระเงิน
      </span>
    </div>
    <div class="w-100pct h-60calc">
      <div class="t-al-center f-s-24px f-w-bold pd-t-48px">
        ราคา {{ netPrice | showFullPriceFormat() }} บาท
      </div>
      <div class="t-al-center f-s-18px mg-t-48px">
        <router-link :to="{ name: 'CheckoutByCard' }">
          <img src="/static/svg/credit.svg" class="w-174px"> <br>
        </router-link>
        ชำระด้วยบัตรเครดิต
      </div>
      <div class="t-al-center f-s-18px mg-t-48px">
        <router-link :to="{ name: 'CheckoutByCash' }">
          <img src="/static/svg/cash.svg" class="w-174px"> <br>
        </router-link>
        ชำระด้วยเงินสด
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'payment',
  computed: {
    ...mapGetters({
      netPrice: 'getNetPrice',
      mainColor: 'mainColor'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/check-out/Payment.vue